import { useEffect, useState } from "react";

const PHONE = "5571991740168"; // (71) 99174-0168 — Jorge
const DEFAULT_MESSAGE = "Olá! Vim pelo site da GOODMAX e gostaria de mais informações.";

export default function WhatsAppButton() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setShow(true), 600);
        return () => clearTimeout(t);
    }, []);

    const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

    return (
        <a
            data-testid="whatsapp-float-btn"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar pelo WhatsApp"
            className={`fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[60] group flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 hover:shadow-xl hover:shadow-[#25D366]/40 transition-all duration-500 ${
                show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
            }`}
        >
            <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full">
                {/* Pulse */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
                <svg
                    viewBox="0 0 32 32"
                    className="relative w-7 h-7 sm:w-8 sm:h-8 fill-white"
                    aria-hidden="true"
                >
                    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.04 1.397-1.04 2.4 0 .53.115 1.06.273 1.56.4 1.288 1.118 2.5 2.005 3.5.616.717 1.297 1.348 2.055 1.892.83.602 1.722 1.075 2.673 1.418.66.244 1.376.345 2.077.345.86 0 1.504-.215 2.057-.802.358-.384.673-.787.673-1.318 0-.5-.272-.886-.587-1.144-.5-.43-.998-.602-1.49-.602z" />
                    <path d="M16 0C7.163 0 0 7.163 0 16c0 2.882.778 5.583 2.13 7.911L0 32l8.31-2.18A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.788-1.86l-.487-.288-5.072 1.33 1.354-4.93-.317-.5A13.31 13.31 0 0 1 2.667 16C2.667 8.633 8.633 2.667 16 2.667S29.333 8.633 29.333 16 23.367 29.333 16 29.333z" />
                </svg>
            </span>
            <span className="hidden sm:inline-block pr-5 font-semibold text-sm whitespace-nowrap">
                Fale conosco
            </span>
        </a>
    );
}
